function initNavigation() {

	//console.log("Pantanenius => init navigation");

	var $logo = $(".navLogoContainer").html();

	//init slicknav
	$('.mainNavigationEntries').children("ul").slicknav({
		prependTo: "#mobileNavigation",
		label: "",
		brand: $logo,
		nestedParentLinks: true,
		closedSymbol: "",
		openedSymbol: "",
		init: function () {
			$(".slicknav_nav").before($(".mobileNavSearchfield"));
		},
		beforeOpen: function () {
			if ($(".slicknav_btn").hasClass("slicknav_open")) {
				$(".mobileNavSearchfield").show();
			}

			if(!$("main").hasClass("navigation-opened")){
				$("main").addClass("navigation-opened");
			}
		},
		afterOpen: function () {
			if(!$(".mobileNavigation").hasClass("mobileNavigation--opened")){
				$(".mobileNavigation").addClass("mobileNavigation--opened");
			}
		},
		beforeClose: function () {
			
		},
		afterClose: function () {
			if ($(".slicknav_btn").hasClass("slicknav_collapsed")) {
				$(".mobileNavSearchfield").hide();
			}
			
			var headerNavActive = $(".headerBarContent").children(".container").hasClass("active");
			var headerLoginActive = $(".headerBarLogin").children(".container").hasClass("active");
			if(!headerNavActive && !headerLoginActive){
				$("main").removeClass("navigation-opened");
			}

			if($(".slicknav_nav").hasClass("slicknav_hidden")){
				$(".mobileNavigation").removeClass("mobileNavigation--opened");
			}
		}
	});

	$(".slicknav_btn").attr("aria-label", "Show navigation");

	//handle close button
	$(".mainNavigationCloseButton").on("click", function () {
		$(".mainNavigationOpened").removeClass("opened");
		hideMainNavigationOpened();
	});
	$('.mainNavigationCloseButton').on("keydown", handleKeyDownForClick);

	//handle background click
	$(".mainNavigationOpenedBackground").on("click", function () {
		$(".mainNavigationOpened").removeClass("opened");
		hideMainNavigationOpened();

		if($(".slicknav_open")){
			$(".slicknav_open").trigger("click");
		}
	});

	//main navigation click
	$('.mainNavigationLink').on("keydown", handleKeyDownForClick);
	$(".mainNavigationLink").on("click",function (event) {

		var href = $(this).attr('href');
		if (typeof href !== 'undefined' && href !== false) {
			//load linked page...
		}
		else {
			event.preventDefault();

			if ($(this).hasClass("active") && $(".mainNavigationOpened").hasClass("opened")) {
				//nav already opened
			}
			else {

				$(".mainNavigationLink").removeClass("active");
				$(this).addClass("active");

				$(".mainNavigationOpened").show();
				$(".mainNavigationOpened").removeClass("opened");
				$(".mainNavigationOpened").addClass("opened");

				$(".mainNavigationEntries").removeClass("opened");
				//$(".mainNavigationEntries").addClass("opened");

				$(".mainNavigationOpened").removeClass("invisible");
				//$(".mainNavigationOpened").addClass("invisible");


				$(".mainNavigationOpenedContent").html("");
				$(".mainNavigationOpenedContent").append($(this).siblings(".mainNavigationContent").clone());
				//$(".headerBarContentBox").hide();

				//close header bar above
				closeHeaderBar();

				//animateNavigationOpened();

				$(".mainNavigationOpened").find(".mainNavigationContent").fadeIn(250, function () {
					updateMainNavigationDesciptionPositions();
					setMainNavigationTooltipListeners();
				});

				if ($(".mainNavigationOpenedContent").find(".articleTeaserImage") && _blazy) {
					_blazy.revalidate();
				}

				if(!$("main").hasClass("navigation-opened")){
					$("main").addClass("navigation-opened");
				}
			}
		}

	});

	$(".mainNavigationSubLink.hasSubPages").click(function () {
		$(this).siblings(".mainNavigationSubContent").show();
	});

	$(".mainNavigationEntries").siblings(".mainNavigationSearchLink").click(function () {
		if ($(".mainNavigation").hasClass("searchActive")) {
			$(".mainNavigation").removeClass("searchActive");
			$(".mainNavigationSearchFieldResults").hide();
			$(".mainNavigationSearchField").find("input[type=text]").val("");
		}
		else {
			consolog("click search link!");
			$(".mainNavigationSearchField").find("input").val("");

			$(".mainNavigationSearchField").find(".mainNavigationSearchFieldResults").hide();

			$(".mainNavigation").addClass("searchActive");

			if ($(".mainNavigationOpened").hasClass("opened")) {
				$(".mainNavigationOpened").removeClass("opened");
				hideMainNavigationOpened();
			}

			$(".mainNavigationSearchField").find("input[type=text]").focus();
		}
	});

	$(".mainNavigationSearchField").find("input").keydown(function () {
		$(".mainNavigationSearchFieldResults").show();
	});

	$(".mobileNavLanguageSwitchButton").click(function (e) {
		e.preventDefault();

		if ($(this).hasClass("open")) {
			$(".mobileNavLanguageSwitch").hide();
			$(this).removeClass("open");
		}
		else {
			$(".mobileNavLanguageSwitch").show();
			$(this).addClass("open");
		}
	});
}

function setMainNavigationTooltipListeners() {
	$(".mainNavigationOpened").find(".hasDescription").each(function () {

		$(this).children(".descriptionIcon").unbind();

		$(this).children(".descriptionIcon").mouseover(function () {
			$(this).siblings(".description").removeClass("visible");
			$(this).siblings(".description").addClass("visible");
		});
		$(this).children(".descriptionIcon").mouseout(function () {
			$(this).siblings(".description").removeClass("visible");
		});
	});
}

function updateMainNavigationDesciptionPositions() {

	//consolog("updateMainNavigationDesciptionPositions()");

	$(".mainNavigationOpened").find(".hasDescription").each(function () {
		//caclulate top margin for positioning the description tooltip
		var navHeight = $(this).height();
		$(this).removeClass("descriptionVisible");
		$(this).addClass("descriptionVisible");
		var descHeight = $(this).children(".description").height();
		$(this).removeClass("descriptionVisible");
		var mt = Math.round(descHeight / 2 - navHeight / 2);

		//set margin to 0
		$(this).children(".description").css("margin-top", "0");

		//set margin to calculated value (on large screens only)
		if (mt > 0 && $(window).width() >= 1200) {
			$(this).children(".description").css("margin-top", -mt + "px");
			//consolog("navHeight:" + navHeight + " descHeight:" + descHeight + " mt:" + mt + " # " + $(this).text());
		}
		else if ($(window).width() < 1200) {
			$(this).children(".description").css("margin-top", "10px");
		}
	});

}

function hideMainNavigationOpened() {

	$(".mainNavigationOpened").hide();
	$(".mainNavigationOpenedContent").html("");
	$(".mainNavigationOpenedContent").css("height", "auto");

	$(".mainNavigationLink").removeClass("active");
	$(".mainNavigationOpened").removeClass("opened");
	$(".mainNavigationEntries").removeClass("opened");

	//hide nav background if other header nav elements are invisible
	var headerNavActive = $(".headerBarContent").children(".container").hasClass("active");
	var headerLoginActive = $(".headerBarLogin").children(".container").hasClass("active");
	if(!headerNavActive && !headerLoginActive){
		$("main").removeClass("navigation-opened");
	}

	/*
	$(".mainNavigationOpenedBackground").animate({
		height: 1
	},
		{
			duration: 0,	//500
			easing: "swing",
			complete: function () {
				//$(".mainNavigationOpened").children().fadeIn(250);
			}
		}
	);
	*/
}

function animateNavigationOpened() {
	var targetHeight = $(".mainNavigationOpened").height();

	$(".mainNavigationOpened").removeClass("invisible");
	$(".mainNavigationOpened").addClass("invisible");

	targetHeight = 1;
	$(".mainNavigationOpenedBackground").animate({
		height: targetHeight
	},
		{
			duration: 0,	//500
			easing: "swing",
			complete: function () {
				$(".mainNavigationOpened").removeClass("invisible");
				$(".mainNavigationOpened").find(".mainNavigationContent").fadeIn(250, function () {
					updateMainNavigationDesciptionPositions();
					setMainNavigationTooltipListeners();
				});
			}
		}
	);
}

function updateNavigationOpenedBackground() {
	//TODO....
}

function startNavigationSvgAnimation() {

	//http://snapsvg.io/start/

	var s = Snap("#mainNavSvg");
	//var bigSquare = s.path("M150,0H0l0,0c24.982,0,54.644,13.313,64.5,41.75C71.76,62.697,85.361,150,112.65,150C137.792,150,147.5,20.43,150,0z");
	var bigSquare = s.path("M150,0H58.875H0c0,0-9.428,11.971-1.25,14.75c56.973,19.358,104.304,43.684,121,90C138.249,156.066,134.569,154.94,150,0z");
	bigSquare.attr({
		fill: "#bada55"
	});

	bigSquare.animate({ path: "M150,0H58.875H0v61.25l150,0.5V0z" }, 5000);

	setTimeout(function () {
		$("#mainNavSvg").addClass("active");
	}, 1000);

}
